import { render, staticRenderFns } from "./RecruitmentManagement.vue?vue&type=template&id=63c8fa0a&scoped=true"
import script from "./RecruitmentManagement.vue?vue&type=script&lang=js"
export * from "./RecruitmentManagement.vue?vue&type=script&lang=js"
import style0 from "./RecruitmentManagement.vue?vue&type=style&index=0&id=63c8fa0a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63c8fa0a",
  null
  
)

export default component.exports